/* eslint-disable no-restricted-syntax */
const hooks = new Set()

export default {
  addHook( fn ) {
    hooks.add( fn )
  },
  removeHook( fn ) {
    hooks.delete( fn )
  },
  removeAllHooks() {
    hooks.clear()
  },
  getParentIndex( items, ref ) {
    const i = Array.isArray( items ) ? items : [ items ]
    for ( const hook of hooks.values() ) {
      const res = hook( i, ref )

      if ( res != null && res !== -1 ) {
        return res
      }
    }

    return -1
  },
  isChildOf( items, ref ) {
    const i = Array.isArray( items ) ? items : [ items ]
    for ( const hook of hooks.values() ) {
      const res = hook( i, ref )

      if ( res != null && res !== -1 ) {
        return true
      }
    }

    return false
  }
}
